module.exports = __webpack_public_path__ + "static/media/ELS38M67.cb6db4e0.png";